import React, { useRef } from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const ContactUs = () => {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_jt54yck",   
        "template_h8flma1",  
        formRef.current,
        "0vqsFxhlILq4aePO-"   
      )
      .then(
        () => {
          alert("Message sent successfully!");
          e.target.reset();
        },
        (error) => {
          alert("Failed to send message. Please try again.");
          console.error("EmailJS error:", error.text);
        }
      );
  };

  const styles = `
    .contact-us-container {
        margin-top: 5rem;
        font-family: 'Poppins', Arial, sans-serif;
        padding: 40px 20px;
        background-color: #FFEDE3;
        color: #333;
        max-width: 1200px;
        margin: 0 auto;
        border-radius: 10px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    }

    .contact-us-header {
        text-align: center;
        margin-bottom: 40px;
        margin-top: 5rem;
    }

    .contact-us-header h1 {
        font-size: 2.5em;
        font-weight: 700;
        color: #ff6600;
    }

    .contact-us-header p {
        color: #666;
        max-width: 600px;
        margin: 10px auto;
        font-weight: 400;
    }

    .contact-us-content {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 40px;
    }

    .contact-details,
    .contact-form-section {
        flex: 1;
        min-width: 300px;
    }

    .contact-details {
        display: flex;
        flex-direction: column;
        gap: 30px;
    }

    .contact-info .info-item {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        font-size: 1.1em;
        color: #555;
        transition: color 0.3s ease;
    }

    .contact-info .info-item:hover {
        color: #ff6600;
    }

    .contact-info .icon {
        font-size: 1.5em;
        margin-right: 15px;
        color: #ff6600;
    }

    .hours h2 {
        font-size: 1.5em;
        margin-bottom: 10px;
    }

    .hours table {
        width: 100%;
        border-collapse: collapse;
    }

    .hours td {
        padding: 8px 0;
        border-bottom: 1px solid #ddd;
    }

    .hours tr:last-child td {
        border-bottom: none;
    }

    .hours tr:nth-child(even) {
        background-color: #f2f2f2;
    }

    .note {
        background-color: #fff2e6;
        color: #d15a00;
        padding: 15px;
        border-left: 5px solid #ff6600;
        border-radius: 5px;
        margin-top: 20px;
    }

    .contact-form-section {
        background-color: #fff;
        padding: 30px;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    }

    .contact-form .form-group-inline {
        display: flex;
        gap: 20px;
        margin-bottom: 20px;
    }

    .contact-form .form-group-inline input {
        flex: 1;
    }
    
    .contact-form .form-group {
      margin-bottom: 20px;
    }

    .contact-form input,
    .contact-form textarea {
        width: 100%;
        padding: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        font-size: 1em;
        transition: border-color 0.3s ease;
    }

    .contact-form input:focus,
    .contact-form textarea:focus {
        outline: none;
        border-color: #ff6600;
        box-shadow: 0 0 5px rgba(255, 102, 0, 0.2);
    }

    .contact-form textarea {
        resize: vertical;
        min-height: 150px;
    }

    .contact-form button {
        width: 100%;
        padding: 15px;
        border: none;
        background-color: #ff6600;
        color: white;
        font-size: 1.2em;
        font-weight: bold;
        border-radius: 2rem;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    .contact-form button:hover {
        background-color: #e65c00;
        box-shadow: 0 4px 15px rgba(255, 102, 0, 0.3);
    }
    
    .testimonial-section {
        background-color: #fff2e6;
        padding: 20px;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        text-align: center;
        margin-top: 5rem; 
    }

    .testimonial-section h2 {
        font-size: 1.4em;
        color: #ff6600;
        margin-bottom: 10px;
    }

    .testimonial-quote {
        font-style: italic;
        color: #555;
        font-size: 1em;
        margin-bottom: 5px;
    }

    .testimonial-author {
        font-weight: 600;
        color: #333;
    }

    @media (max-width: 768px) {
        .contact-us-content {
            flex-direction: column;
        }
    }
  `;

  return (
    <div className="contact-us-container">
      <style>{styles}</style>
      <div className="contact-us-header">
        <h1>Contact Us</h1>
        <p>
          Have questions or feedback? We'd love to hear from you. Get in touch
          with us using any of the methods below.
        </p>
      </div>

      <div className="contact-us-content">
        <div className="contact-details">
          <div className="contact-info">
            <div className="info-item">
              <FaEnvelope className="icon" />
              <span>tifdefoods@mykitchen.in</span>
            </div>
            <div className="info-item">
              <FaMapMarkerAlt className="icon" />
              <span>Hyderabad, Telangana, India</span>
            </div>
            <div className="info-item">
              <FaPhone className="icon" />
              <span>+91 756-954-8045</span>
            </div>
          </div>

          <div className="hours">
            <h2>Hours:</h2>
            <table>
              <tbody>
                <tr><td>Monday</td><td>09:00am - 07:00pm</td></tr>
                <tr><td>Tuesday</td><td>09:00am - 07:00pm</td></tr>
                <tr><td>Wednesday</td><td>09:00am - 07:00pm</td></tr>
                <tr><td>Thursday</td><td>09:00am - 07:00pm</td></tr>
                <tr><td>Friday</td><td>09:00am - 07:00pm</td></tr>
                <tr><td>Saturday</td><td>10:00am - 05:00pm</td></tr>
                <tr><td>Sunday</td><td>Closed</td></tr>
              </tbody>
            </table>
          </div>

          <div className="note">
            Note: Orders for next-day delivery must be placed before 6:00 PM.
          </div>
          <div className="note">
            Note: For catering or bulk orders, please contact us directly.
          </div>
        </div>

        <div className="contact-form-section">
          <form ref={formRef} className="contact-form" onSubmit={sendEmail}>
            <div className="form-group-inline">
              <input type="text" name="user_name" placeholder="First name" required />
              <input type="email" name="user_email" placeholder="abc@email.com" required />
            </div>
            <div className="form-group">
              <input type="text" name="subject" placeholder="Enter Your Subject" required />
            </div>
            <div className="form-group">
              <textarea name="message" placeholder="Leave us a message..." required></textarea>
            </div>
            <button type="submit">Send message</button>

            <div className="testimonial-section">
              <h2>What Our Customers Say</h2>
              <p className="testimonial-quote">
                "The food is not only delicious but also beautifully presented. The quality and taste are unmatched!"
              </p>
              <p className="testimonial-author">- Happy Customer</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
